module.exports = __webpack_public_path__ + "img/40_6.319f6906.png";